import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class ExecutionReportTotalDto {
  @Transform(({ value }) => toEuros(value))
  totalAmount = 0;
}
